import { Stack, styled } from "@mui/material";
import { cardName } from "../classes.js";
const Actions = styled(Stack, {
  name: cardName,
  slot: "actions",
  overridesResolver: (_, styles) => [styles.actions]
})`
  align-items: flex-start;
  flex: 0 0 auto;
  justify-content: center;
  margin-left: auto;
`;
export {
  Actions
};
//# sourceMappingURL=Actions.js.map
